import $ from 'jquery'
import draggable from 'vuedraggable';
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';

export default {
    name: 'manage-section',
    components: {
        draggable, VueEditor
    },
    props: {
        selected_consultation: Object,
        selected_fiche: Object,
        liste_autre_consultations: Array,
        default_consultation_sections: Array,
        liste_sections: Array,
        info_user: Object,
        section_to_edit: Object,
        edit_modal_toggler: Number,
        champ_to_edit: {
            type: Object,
            default: () => ({}) // Default value is an empty object
        },
        liste_champs: {
            type: Array,
            default: () => ([])
        },
        is_champ_ordering: {
            type: Number,
            default: () => (0)
        }
    },
    data() {
        return {
            customToolbar: vueEditorToolbar,
            info_section: {
                nom_section: "",
                is_certif_type: 0,
                liste_champs: [
                    {
                        champ_id: 0,
                        champ: '',
                        type: '',
                        tmp_type_champ: '',
                        occurences: [],
                        tmp_occurence: '',
                        tmp_existing_occurences: [],
                        can_show_occurence: false,
                        is_required: 0,
                        default_content: ''
                    }
                ]
            },
            selected_type_champ: '',
            c_occurence: '',
            filtered_occurence: [],

            can_show_occurence: false,
            is_next: false,

            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: [],

            save_loading: false,
            err_message: '',
            nom_section: '',

            modal_title: 'Nouvelle section',
            is_edit: false,
            label_ordering: '',
            clip_loading: true
        }
    },

    watch: {
        edit_modal_toggler() {
            if (this.is_champ_ordering == 0) {  // Section ordering
                this.label_ordering = 'sections'
            } else {
                this.label_ordering = 'champs'
            }
            
            this.err_message = ''
            console.log(">> add champs");
            
            this.fillSectionToEdit()

            this.info_section.liste_champs = [
                {
                    champ_id: 0,
                    champ: '',
                    type: '',
                    tmp_type_champ: '',
                    occurences: [],
                    tmp_occurence: '',
                    tmp_existing_occurences: [],
                    can_show_occurence: false,
                    is_required: 0,
                    default_content: ''
                }
            ]

            this.is_edit = false

            if (Object.prototype.hasOwnProperty.call(this.section_to_edit, 'section')) {
                this.modal_title = 'Nouveaux Champs'

                if (Object.prototype.hasOwnProperty.call(this.champ_to_edit, 'champ')) {
                    this.modal_title = 'Modifier Champ'
                    this.is_edit = true
                }
                this.autoFillFields()
            }
        }
    },

    computed: {
        type_champs() {
            return this.$store.getters["type_champs"];
        },

        liste_occurences() {
            return this.$store.getters["liste_occurences"];
        },

        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        },
    },

    mounted() {
        // Liste type de champs
        this.$store.dispatch("getTypeChamps")

        // Liste occurences
        this.$store.dispatch("getListeOccurences")
        this.getCertifClipBoard()
    },

    methods: {
        getCertifClipBoard() {
            this.clip_loading = true
            this.$store.dispatch("getListeTypeMixData", 'certif_placeholder').then(() => {
                this.clip_loading = false
            })
        },

        addToOccurence(cindex) {
            this.info_section.liste_champs[cindex].tmp_existing_occurences = [];
            if (this.info_section.liste_champs[cindex].tmp_occurence.length >= 2) {
                this.liste_occurences.forEach(
                    el => {
                        if (el.occurence.toLowerCase().includes(this.info_section.liste_champs[cindex].tmp_occurence.toLowerCase())) {
                            this.info_section.liste_champs[cindex].tmp_existing_occurences.push(el)
                        }
                    }
                )
            }
        },

        /**
         * Ajouter une nouvelle occurence
         */
        addNewOccurence(cindex) {
            let j = 0
            let len = this.info_section.liste_champs[cindex].occurences.length

            let tmp_occ = this.info_section.liste_champs[cindex].tmp_occurence

            let tmp_occurence = {
                id: 0,
                occurence: tmp_occ
            }

            // Verifier si occurence déjà choisi
            if (len > 0) {
                for (let i = 0; i < len; i++) {
                    if (tmp_occ == this.info_section.liste_champs[cindex].occurences[i].occurence) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.info_section.liste_champs[cindex].occurences.push(tmp_occurence)

                this.info_section.liste_champs[cindex].tmp_occurence = ''
                this.filtered_motif = []
            }
        },

        addExistingOccurence(data, cindex) {
            let j = 0
            let len = this.info_section.liste_champs[cindex].occurences.length

            let tmp_occurence = {
                id: 0,
                occurence: data.occurence
            }

            // Verifier si occurence déjà choisi
            if (len > 0) {
                for (let i = 0; i < len; i++) {
                    if (data.occurence == this.info_section.liste_champs[cindex].occurences[i].occurence) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.info_section.liste_champs[cindex].occurences.push(tmp_occurence)

                this.info_section.liste_champs[cindex].tmp_occurence = ''

            }
            this.info_section.liste_champs[cindex].tmp_existing_occurences = []
        },

        removeOccurence(index, cindex) {
            this.info_section.liste_champs[cindex].occurences.splice(index, 1)
        },

        onTypeChange(index) {
            let selected_type_champ = this.info_section.liste_champs[index].tmp_type_champ
            
            let split_type_champ = selected_type_champ.split('.')
            this.info_section.liste_champs[index].type = parseInt(split_type_champ[0])

            if (
                split_type_champ[1] == 'Choix déroulant' || split_type_champ[1] == 'Case à cocher' || 
                split_type_champ[1] == 'Choix unique' || split_type_champ[1] == 'Choix multiple'
            ) {
                this.info_section.liste_champs[index].can_show_occurence = true
            } else {
                this.info_section.liste_champs[index].can_show_occurence = false
            }
        },

        addField() {
            this.info_section.liste_champs.push(
                {
                    champ_id: 0,
                    champ: '',
                    type: '',
                    tmp_type_champ: '',
                    occurences: [],
                    tmp_occurence: '',
                    can_show_occurence: false,
                    is_required: 0,
                    default_content: ''
                }
            )

            if (this.info_section.is_certif_type == '1') {
                setTimeout(() => {
                    this.onTypeCertifChange('1')
                }, 500);
            }
            
        },

        removeField(index) {
            this.info_section.liste_champs.splice(index, 1)
        },

        toggleStep() {
            this.is_next = true
        },

        backToForm() {
            this.is_next = false
        },

        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.liste_autre_consultations.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.liste_autre_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("consult-tous").checked = false;
        },

        saveReorder() {
            let data = {}
            if (this.label_ordering == 'sections') {
                data = {
                    fiche_consultation_id: this.selected_fiche.id,
                    sections: this.liste_sections
                }
            } else {
                const fcs_id = (Object.prototype.hasOwnProperty.call(this.section_to_edit, 'fcs_id'))?this.section_to_edit.fcs_id:0
                data = {
                    fcs_id: fcs_id,
                    champs: this.liste_champs
                }
            }

            console.log(">> ",data);
            
            
            this.save_loading = true
            const dispatch_fiche = (this.label_ordering == 'sections')?'saveFicheSectionOrder':'saveFicheChampOrder'

            this.$store.dispatch(dispatch_fiche ,data).then((response) => {
                if (response.success) {
                    this.$refs.order_section.click()
                    this.successToast(response.message)
                    this.$emit('emitSection')
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        },

        async saveSection() {
            this.err_message = ''
            const isValid = await this.$refs.fiche_champ_form.validate();
            if (!isValid) {
                return;
            }

            const fcs_id = (Object.prototype.hasOwnProperty.call(this.section_to_edit, 'fcs_id'))?this.section_to_edit.fcs_id:0

            let data = {
                type_consultation_id: this.selected_consultation.id,
                fiche_consultation_id: this.selected_fiche.id,
                section: this.info_section.nom_section,
                is_certif_type: parseInt(this.info_section.is_certif_type),
                liste_champs: this.info_section.liste_champs,
                user_id: this.info_user.id,
                fcs_id: fcs_id
            }

            this.save_loading = true
            let dispatch_fiche = (fcs_id == 0)?'saveSectionFicheConsultation':'gererChampsFicheConsultation'
            this.$store.dispatch(dispatch_fiche, data).then((response) => {
                if (response.success) {
                    this.$refs.n_section.click()
                    this.successToast(response.message)

                    this.info_section.liste_champs.push(
                        {
                            champ_id: 0,
                            champ: '',
                            type: '',
                            tmp_type_champ: '',
                            occurences: [],
                            tmp_occurence: '',
                            can_show_occurence: false,
                            is_required: 0,
                            default_content: ''
                        }
                    )
                } else {
                    this.err_message = response.message
                }
                if (fcs_id > 0) {
                    this.$emit('emitSecionChamp')
                } else {
                    this.$emit('emitSection')
                }
                
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.err_message = "Une erreur s'est produite"
            })
        },

        fillSectionToEdit() {
            this.nom_section = this.section_to_edit.section
        },

        async editSection() {
            this.err_message = ''
            const isValid = await this.$refs.edit_section_form.validate();
            if (!isValid) {
                return;
            }

            let data = {
                section: this.nom_section,
                section_id: this.section_to_edit.section_id
            }
            this.save_loading = true
            
            store_fiche.editerNomSection(data).then((response) => {
                if (response.success) {
                    this.$refs.e_section.click()
                    this.successToast(response.message)
                    this.$emit('emitSection')
                } else {
                    this.err_message = response.message
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.err_message = "Une erreur s'est produite"
            })
        },

        autoFillFields() {
            this.info_section.nom_section = this.section_to_edit.section
            this.info_section.is_certif_type = this.section_to_edit.is_certif_type 

            this.info_section.liste_champs = [
                {
                    champ_id: this.champ_to_edit.champ_id,
                    champ: this.champ_to_edit.champ,
                    type: this.champ_to_edit.type_champ_id,
                    tmp_type_champ: ''+this.champ_to_edit.type_champ_id+'.'+this.champ_to_edit.type_champ,
                    occurences: this.champ_to_edit.occurences,
                    tmp_occurence: '',
                    tmp_existing_occurences: [],
                    can_show_occurence: (this.champ_to_edit?.occurences.length > 0)?true:false,
                    is_required: this.champ_to_edit.est_requis,
                    default_content: this.champ_to_edit.default_value
                }
            ]
            
        },

        onTypeCertifChange(value) {
            let chmp_editor = ''
            let chmp_editor_id = 0
            if (value == '1') {
                // Loop type_champs and store value into chmp_editor if only the value equals Editeur de texte
                this.type_champs.forEach(type => {
                    if (type.champ == "Editeur de texte") {
                        chmp_editor = type.champ_id+'.'+type.champ
                        chmp_editor_id = type.champ_id
                    }
                });

                for (let i = 0; i < this.info_section.liste_champs.length; i++) {
                    this.info_section.liste_champs[i].type = chmp_editor_id
                    this.info_section.liste_champs[i].tmp_type_champ = chmp_editor

                    this.info_section.liste_champs[i].can_show_occurence = false
                    this.info_section.liste_champs[i].occurences = []
                    this.info_section.liste_champs[i].tmp_existing_occurences = []
                }
            } else {
                for (let i = 0; i < this.info_section.liste_champs.length; i++) {
                    this.info_section.liste_champs[i].default_content = ''
                }
            }
        },

        async copyToClipboard(char, event) {
            event.preventDefault()
            try {
                await navigator.clipboard.writeText(char);
                $('.toggle-clip-action').fadeIn(200).delay(1000).fadeOut(200);
            } catch (err) {
                console.error('Failed to copy text: ', err);
                $('.toggle-clip-error').fadeIn(200).delay(1000).fadeOut(200);
            }
        },
    }
}